import { Chart, type Plugin } from 'chart.js';
import { getColors } from 'contexts';

// Custom plugin to draw datalabels on pie chart
export const customDatalabelsPlugin: Plugin = {
  id: 'customDatalabels',
  afterDatasetsDraw(chart: Chart) {
    if (chart.config.type !== 'pie') return;

    const { ctx, data, chartArea } = chart;
    if (!ctx || !chartArea || !data) return;

    const centerX = (chartArea.left + chartArea.right) / 2;
    const centerY = (chartArea.top + chartArea.bottom) / 2;
    const radius =
      Math.min(
        chartArea.right - chartArea.left,
        chartArea.bottom - chartArea.top,
      ) / 2;

    ctx.font = '600 16px sans-serif';
    ctx.fillStyle = getColors().black;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    let currentAngle = -Math.PI / 2;

    data.datasets.forEach((dataset, datasetIndex) => {
      (dataset.data as number[]).forEach((value, index) => {
        const meta = chart.getDatasetMeta(datasetIndex);
        const arc = meta.data[index];

        if (!arc) return;

        const label = data.labels?.[index];
        const sliceAngle = (arc as any).circumference;
        const labelAngle = currentAngle + sliceAngle / 2;

        const labelRadius = radius * 0.7;
        const x = centerX + labelRadius * Math.cos(labelAngle);
        const y = centerY + labelRadius * Math.sin(labelAngle);

        ctx.fillText(String(label), x, y);

        currentAngle += sliceAngle;
      });
    });
  },
};
